import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { useResizeDetector } from 'react-resize-detector';
import { useTheme } from '@mui/material/styles';
import { MainStore } from '@gamiphy/loyalty-station-desktop/store/ui/main';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { getThemeFontStyleSheets } from '@gamiphy/loyalty/theme';
import MainContent from './MainContent';

const Main: React.FC = observer(() => {
  React.useEffect(() => {
    const closeLS = () => {
      UiStore.close();
    };
    // clicks inside any LS frame will not be caught here, only clicks in the main website:
    window.addEventListener('click', closeLS);

    return () => {
      window.removeEventListener('click', closeLS);
    };
  }, []);

  const theme = useTheme();

  const {
    width,
    height,
    ref,
  } = useResizeDetector();

  React.useEffect(() => {
    if (width && height) {
      MainStore.setDimensions({
        width,
        height,
      });
    }
  }, [width, height]);

  return (
    <div
      ref={ref}
      style={{
        padding: '0 !important',
        position: 'relative',
        zIndex: 2147483645,
        width: '100%',
        height: '100%',
        left: 0,
        fontWeight: 700,
        transition: `left 1s ${theme.transitions.easing.easeOut}`,
      }}
    >
      <FramePortal
        stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
        theme={theme}
        dir={AppStore.dir}
      >
        <MainContent />
      </FramePortal>
    </div>
  );
});

export default Main;
